import { Component, Vue, Watch } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import { getTemplateByFunctionsId, importTemplateData} from '@/api/common'
import { formatDate } from '@/utils/timeFilter'
import { menuBtn } from '@/utils/menu_level2_button'
import { delNullProperty } from '@/utils/index'
import realTimeSokcet from '@/utils/socket.io'

const statusFilter = [
    { key: '市场线索', value: 1 },
    { key: '合作管理', value: 3 },
    { key: 'B端客户', value: 5 },
]

@Component({})
export default class BulkImport extends Vue {
    status = null  //数据类型
    uploadDialogs = false
    dialogTitle = ''
    resultDialog = false
    statusFilter = statusFilter
    dialogName = ''
    uploadData = null
    socket: any = null
    loading = false
    file = []
    menuBtn = menuBtn
    readyOption = true
    uploadNum = {
        successNum: 0,
        failNum: 0,
        allNum: 0,
        url: '',
    }
    fileData = null
    // computed
    get userList() {
        return UserModule.userList
    }
    get userId() {
        return UserModule.userId
    }

    // created 
    created() {}

    // methods 
    handleStatus(val){
        this.status = val
        let name = statusFilter.filter(item => item.value == val)
        this.dialogName = name[0].key
    }
    async downloadTemplate(){
        if (!this.status) {
            this.$message.error('请选择数据类型')
            return
        }
        const data: any = await getTemplateByFunctionsId(this.status)
        const a: any = document.createElement('a')
        a.href = data.url //  URL对象
        a.click() // 模拟点击
    }
    async sureExport() {
        this.uploadDialogs = true
        const formData = new FormData()
        formData.append('file', this.file[0].raw)
        formData.append('functionsId', this.status)
        
        importTemplateData(formData).then((res) => {
            const { allNum, failNum, successNum, url } = res as unknown as { allNum: number; failNum: number; successNum: number; url: string }
            this.uploadNum = {  allNum, failNum, successNum, url }
            this.uploadData = this.uploadNum
            // // 成功后就展示成功提示
            this.dialogTitle = `批量导入${this.status == '1' ? '市场线索' : this.status == '3' ? '合作伙伴' : this.status == '5' ? 'B端客户' : ''}`
            this.resultDialog = true
            this.uploadDialogs = false
            this.file = []
            this.fileData = {}
        }).catch(err => {
            console.log(err)
            this.resultDialog = false
            this.uploadDialogs = false
        })
    }




    uploadprogress() {
        this.loading = true
    }

    // 下载表格数据
    uploadExcel() {
        const url = this.uploadData.url
        const a: any = document.createElement('a')
        a.href = url
        a.click()
    }
    handleFile(){
        if(this.status){
            this.readyOption = false
        }else {
            this.$message.error('请选择数据类型')
            return
        }
    }
    handleFileChange(file,fileList) {
        const upload: any = this.$refs.upload
        upload.clearFiles()
        this.file = fileList.slice(-1);
    }


    // @Watch('userId')
    // handleWatchUserId() {
    //     this.initSocket()
    // }
}